import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentApiService } from '@uc/utilities';

@Injectable({
	providedIn: 'root',
})
export class ReportModalApiService {
	reviewId!: number;

	constructor(
		private _http: HttpClient,
		private _apiSrv: EnvironmentApiService,
	) {}

	setReviewId(reviewId: number) {
		this.reviewId = reviewId;
	}

	submitReport(params: { email: string; message: string }) {
		return this._http.post<any>(
			`${this._apiSrv.API_URL}reviews/${this.reviewId}/report`,
			params,
			{
				transferCache: false,
			},
		);
	}
}
